import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getGlobalAlertList, closeGlobalAlertApi } from "@/api/organization";
import { message } from "antd";

import { campaignSimpleUpdateApi } from "@/api/campaignList";
import AlertCard from "./AlertCard";
import { CampaignMarketingStrategy } from "@/pages/campaignCreate/config";
import { AlertTypeEnum } from "./config";
import { useNavigate } from "react-router-dom";
import { useModalStore } from "@/hooks/useModalStore";
import { useClerk } from "@clerk/clerk-react";
import { isMobile } from "@/biz/tool";

export default function GlobalAlert() {
  const { t } = useTranslation();
  const [pauseList, setPauseList] = useState([]);
  const [budgetList, setBudgetlist] = useState([]);
  const [affiliateBudgetList, setAffiliateBudgetList] = useState([]);
  const [reviewApprovedList, setReviewApprovedList] = useState([]);
  const [reviewRejected, setReviewRejected] = useState([]);
  const navigate = useNavigate();
  const { setChangeBudgetModalInfo } = useModalStore();

  const getAlertList = async () => {
    try {
      const res = await getGlobalAlertList();
      setBudgetlist(res?.costGt80Influencer);
      setAffiliateBudgetList(res?.costGt80Affiliate);
      setPauseList(res?.systemTempPaused);
      setReviewApprovedList(res?.reviewApproved);
      setReviewRejected(res?.reviewRejected);
    } catch (error) {
      // error
    }
  };

  const { organization } = useClerk();
  useEffect(() => {
    if (organization?.id) {
      getAlertList();
    }
  }, []);

  const handleClose = async (type: AlertTypeEnum, item: any) => {
    const listMap: Record<AlertTypeEnum, any[]> = {
      [AlertTypeEnum.systemTempPaused]: pauseList,
      [AlertTypeEnum.costGt80Influencer]: budgetList,
      [AlertTypeEnum.costGt80Affiliate]: affiliateBudgetList,
      [AlertTypeEnum.reviewApproved]: reviewApprovedList,
      [AlertTypeEnum.reviewRejected]: reviewRejected,
    };
    const originalList = listMap[type] || [];
    const updatedList: any = [...originalList].map((v) => ({
      ...v,
      hidden: v.campaignId === item.campaignId ? true : v.hidden,
    }));
    const setListMap = {
      [AlertTypeEnum.systemTempPaused]: setPauseList,
      [AlertTypeEnum.costGt80Influencer]: setBudgetlist,
      [AlertTypeEnum.costGt80Affiliate]: setAffiliateBudgetList,
      [AlertTypeEnum.reviewApproved]: setReviewApprovedList,
      [AlertTypeEnum.reviewRejected]: setReviewRejected,
    };
    const setList = setListMap[type];
    setList && setList(updatedList);
    try {
      await closeGlobalAlertApi(item.campaignId, {
        type:
          type === AlertTypeEnum?.reviewApproved ||
          type === AlertTypeEnum?.reviewRejected
            ? "review"
            : type,
      });
    } catch (error) {}
  };

  const handleResume = async (item: any) => {
    try {
      await campaignSimpleUpdateApi(item?.campaignId);
      handleClose(AlertTypeEnum.systemTempPaused, item);
      window.location.reload();
    } catch (error) {
      message.error(`${error}`);
    }
  };

  if (isMobile()) {
    return null;
  }

  if (
    !pauseList.length &&
    !budgetList?.length &&
    !affiliateBudgetList?.length &&
    !reviewApprovedList?.length &&
    !reviewRejected?.length
  ) {
    return null;
  }

  return (
    <div className="fixed flex flex-col gap-4 top-4 md:top-[40px] right-0 md:right-[40px] w-full md:w-[380px] z-[999] px-4 md:px-0">
      {budgetList?.map((item: any) => (
        <AlertCard
          key={item?.campaignId}
          item={item}
          handleClose={() =>
            handleClose(AlertTypeEnum.costGt80Influencer, item)
          }
          title={t('components.globalAlert.lowBudgetInfluencer.title', { campaignName: item?.name })}
          desc={t('components.globalAlert.lowBudgetInfluencer.desc')}
          confirmText={t('components.globalAlert.lowBudgetInfluencer.confirmText')}
          cancelText={t('components.globalAlert.lowBudgetInfluencer.cancelText')}
          handleConfim={() => {
            setChangeBudgetModalInfo({
              visible: true,
              campaignId: item?.campaignId,
              budget:item?.budgetLimitMonthly,
              marketingStrategy: CampaignMarketingStrategy.INFLUENCER_MARKETING,
            });
          }}
          handleCancle={() => {
            navigate(`/campaign/detail/${item?.campaignId}/info`);
            handleClose(AlertTypeEnum.systemTempPaused, item);
          }}
        />
      ))}
      {pauseList?.map((item: any) => (
        <AlertCard
          key={item?.campaignId}
          item={item}
          handleClose={() => handleClose(AlertTypeEnum.systemTempPaused, item)}
          title={t('components.globalAlert.campaignPaused.title', { campaignName: item?.name })}
          desc={t('components.globalAlert.campaignPaused.desc')}
          confirmText={t('components.globalAlert.campaignPaused.confirmText')}
          cancelText={t('components.globalAlert.campaignPaused.cancelText')}
          handleConfim={() => handleResume(item)}
          handleCancle={() => {
            navigate(`/campaign/detail/${item?.campaignId}/info`);
            handleClose(AlertTypeEnum.systemTempPaused, item);
          }}
        />
      ))}
      {reviewApprovedList?.map((item: any) => (
        <AlertCard
          key={item?.campaignId}
          item={item}
          handleClose={() => handleClose(AlertTypeEnum.reviewApproved, item)}
          title={t('components.globalAlert.campaignApproved.title', { campaignName: item.name })}
          desc={t('components.globalAlert.campaignApproved.desc')}
          confirmText={t('components.globalAlert.campaignApproved.confirmText')}
          cancelText={t('components.globalAlert.campaignApproved.cancelText')}
          handleConfim={() => {
            navigate(`/campaign/detail/${item?.campaignId}/info`);
            handleClose(AlertTypeEnum.systemTempPaused, item);
          }}
          handleCancle={() => handleClose(AlertTypeEnum.reviewApproved, item)}
        />
      ))}
      {reviewRejected?.map((item: any) => (
        <AlertCard
          key={item?.campaignId}
          item={item}
          handleClose={() => handleClose(AlertTypeEnum.reviewRejected, item)}
          title={t('components.globalAlert.campaignRejected.title', { campaignName: item.name })}
          desc={t('components.globalAlert.campaignRejected.desc')}
          confirmText={t('components.globalAlert.campaignRejected.confirmText')}
          cancelText={t('components.globalAlert.campaignRejected.cancelText')}
          handleConfim={() => {
            navigate(`/campaign/detail/${item?.campaignId}/collaboration`);
            handleClose(AlertTypeEnum.systemTempPaused, item);
          }}
          handleCancle={() => handleClose(AlertTypeEnum.reviewRejected, item)}
        />
      ))}
    </div>
  );
}
